// @ts-nocheck
/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Boundary} from './boundary.js'
import {Id} from './id.js'
import {SetBool} from './set-bool.js'
import {SetColor} from './set-color.js'
import {SetFloat} from './set-float.js'
import {SetString} from './set-string.js'

export class ModifyStyle {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyStyle {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyStyle(bb: flatbuffers.ByteBuffer, obj?: ModifyStyle): ModifyStyle {
    return (obj || new ModifyStyle()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyStyle(bb: flatbuffers.ByteBuffer, obj?: ModifyStyle): ModifyStyle {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyStyle()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  start(obj?: Boundary): Boundary | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Boundary()).__init(this.bb_pos + offset, this.bb!) : null
  }

  end(obj?: Boundary): Boundary | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Boundary()).__init(this.bb_pos + offset, this.bb!) : null
  }

  textField(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  bold(obj?: SetBool): SetBool | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new SetBool()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  italic(obj?: SetBool): SetBool | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? (obj || new SetBool()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  underline(obj?: SetBool): SetBool | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? (obj || new SetBool()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  highlight(obj?: SetColor): SetColor | null {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? (obj || new SetColor()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  familyName(obj?: SetString): SetString | null {
    const offset = this.bb!.__offset(this.bb_pos, 18)
    return offset ? (obj || new SetString()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  size(obj?: SetFloat): SetFloat | null {
    const offset = this.bb!.__offset(this.bb_pos, 20)
    return offset ? (obj || new SetFloat()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  foregroundColor(obj?: SetColor): SetColor | null {
    const offset = this.bb!.__offset(this.bb_pos, 22)
    return offset ? (obj || new SetColor()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  link(obj?: SetString): SetString | null {
    const offset = this.bb!.__offset(this.bb_pos, 24)
    return offset ? (obj || new SetString()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  superscript(obj?: SetBool): SetBool | null {
    const offset = this.bb!.__offset(this.bb_pos, 26)
    return offset ? (obj || new SetBool()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  subscript(obj?: SetBool): SetBool | null {
    const offset = this.bb!.__offset(this.bb_pos, 28)
    return offset ? (obj || new SetBool()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  strikethrough(obj?: SetBool): SetBool | null {
    const offset = this.bb!.__offset(this.bb_pos, 30)
    return offset ? (obj || new SetBool()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  code(obj?: SetBool): SetBool | null {
    const offset = this.bb!.__offset(this.bb_pos, 32)
    return offset ? (obj || new SetBool()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  static startModifyStyle(builder: flatbuffers.Builder) {
    builder.startObject(15)
  }

  static addStart(builder: flatbuffers.Builder, startOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, startOffset, 0)
  }

  static addEnd(builder: flatbuffers.Builder, endOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, endOffset, 0)
  }

  static addTextField(builder: flatbuffers.Builder, textFieldOffset: flatbuffers.Offset) {
    builder.addFieldStruct(2, textFieldOffset, 0)
  }

  static addBold(builder: flatbuffers.Builder, boldOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, boldOffset, 0)
  }

  static addItalic(builder: flatbuffers.Builder, italicOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, italicOffset, 0)
  }

  static addUnderline(builder: flatbuffers.Builder, underlineOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, underlineOffset, 0)
  }

  static addHighlight(builder: flatbuffers.Builder, highlightOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, highlightOffset, 0)
  }

  static addFamilyName(builder: flatbuffers.Builder, familyNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, familyNameOffset, 0)
  }

  static addSize(builder: flatbuffers.Builder, sizeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, sizeOffset, 0)
  }

  static addForegroundColor(builder: flatbuffers.Builder, foregroundColorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, foregroundColorOffset, 0)
  }

  static addLink(builder: flatbuffers.Builder, linkOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, linkOffset, 0)
  }

  static addSuperscript(builder: flatbuffers.Builder, superscriptOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, superscriptOffset, 0)
  }

  static addSubscript(builder: flatbuffers.Builder, subscriptOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, subscriptOffset, 0)
  }

  static addStrikethrough(builder: flatbuffers.Builder, strikethroughOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, strikethroughOffset, 0)
  }

  static addCode(builder: flatbuffers.Builder, codeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, codeOffset, 0)
  }

  static endModifyStyle(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // start
    builder.requiredField(offset, 6) // end
    return offset
  }
}
